import { memo } from 'react';
import AddRowButton from '@/components/table/add-row-button.component';

const EmptyTable = () => {
  return (
    <div className="absolute inset-0 flex h-full w-full flex-col items-center justify-center bg-mono-1">
      <span>Click add to start creating your SWMS</span>
      <AddRowButton />
    </div>
  );
};

export default memo(EmptyTable);
